export default "__VITE_ASSET__IrWtVD4q__"